import _ from "lodash";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import * as Pages from "./pages";
import React from "react";
import { PageStore } from "./stores";
import { withPage } from "./hoc";

/**
 * ApplicationRouter
 */
export default class ApplicationRouter extends React.Component {
  static displayName = "ApplicationRouter";
  static propTypes = {};
  static defaultProps = {};
  /**
   * @constructor
   * @param {Object} props
   */
  constructor(props) {
    super(props);
    _.bindAll(this, "routes");
  }

  routes() {
    const routes = _.flatten(
      _.map(PageStore.getState().pages, (pageList, pageType) => {
        if (!_.has(Pages, pageType)) {
          console.error(`${pageType} does not exists on Pagse`, { Pages });
          return null;
        }

        return pageList
          .map((pageDoc) => {
            const routeOptions = {
              key: pageDoc.ID,
              path: pageDoc.Path,
              component: withPage(Pages[pageType], pageDoc),
              exact: true,
            };
            return {
              path: pageDoc.Path,
              route: <Route {...routeOptions} exact />,
            };
          })
          .toArray();
      }).filter(Boolean)
    );
    return routes;
  }

  /**
   * @override
   */
  render() {
    const forceRefresh = _.isNil(window.history.pushState);
    return (
      <Router forceRefresh={forceRefresh}>
        <Switch>
          {_.map(
            _.orderBy(
              this.routes(),
              ["path"], // Sort by first (path)
              ["desc"]
            ),
            "route"
          )}
          <Route path="/Security/*" component={Pages.Login} />
          <Route
            component={withPage(
              Pages.Error404,
              PageStore.getState().pages.HomePage.first()
            )}
          />
        </Switch>
      </Router>
    );
  }
}



// WEBPACK FOOTER //
// ./src/ApplicationRouter.js